<template>
  <el-dialog
    :visible.sync="localIsShowFilterModal"
    :show-close="false"
    fullscreen
  >
    <div class="search">
      <!-- header -->
      <div class="search__header flex center gaps">
        <div class="box">
          <h3 class="title">
            絞り込み
          </h3>
        </div>
        <div class="box grow" />
        <div class="box">
          <el-button
            icon="el-icon-close"
            type="plain"
            size="medium"
            circle
            @click="localIsShowFilterModal = false"
          />
        </div>
      </div>

      <!-- body -->
      <div class="search__body">
        <el-form
          :model="filterConditions"
          :hide-required-asterisk="true"
        >
          <strong>店舗情報</strong>

          <!-- 1行目: 店舗・支店 -->
          <el-row :gutter="15">
            <!-- 店舗 -->
            <el-col :span="6">
              <p>店舗</p>
              <el-form-item
                prop="clientGroup"
                style="display: inline-block;"
              >
                <el-select
                  placeholder="店舗"
                  :value="clientGroup.name"
                  @change="onChangeClientGroup($event)"
                >
                  <el-option
                    :value="{}"
                    label="未選択"
                  />
                  <el-option
                    v-for="clientGroup in clientGroupList"
                    :key="clientGroup.id"
                    :label="clientGroup.name"
                    :value="clientGroup"
                  >
                    {{ clientGroup.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 支店 -->
            <el-col :span="6">
              <p>支店</p>
              <el-form-item
                prop="deliveryDestination"
                style="display: inline-block;"
              >
                <el-select
                  placeholder="支店"
                  :value="deliveryDestination.name"
                  :disabled="!filterConditions.clientGroupId"
                  @change="onChangeDeliveryDestination($event)"
                >
                  <el-option
                    label="未選択"
                    :value="{}"
                  />
                  <el-option
                    v-for="deliveryDestination in deliveryDestinationList"
                    :key="deliveryDestination.id"
                    :label="deliveryDestination.name"
                    :value="deliveryDestination"
                  >
                    {{ deliveryDestination.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <strong>顧客情報</strong>

          <!-- 2行目: お名前・電話番号 -->
          <el-row :gutter="15">
            <!-- お名前 -->
            <el-col :span="6">
              <p>お名前</p>
              <el-form-item prop="customerName">
                <el-input
                  v-model="filterConditions.customerName"
                  placeholder="お名前"
                  class="e-input"
                />
              </el-form-item>
            </el-col>

            <!-- 電話番号 -->
            <el-col :span="6">
              <p>電話番号</p>
              <el-form-item
                prop="tel"
                :rules="[
                  {
                    pattern: /^[0-9\-]+$/,
                    message: '半角英数、-（半角ハイフン）で入力してください。'
                  }
                ]"
              >
                <el-input
                  v-model="filterConditions.tel"
                  placeholder="電話番号"
                  class="e-input"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 3行目: 郵便番号・住所 -->
          <el-row :gutter="15">
            <!-- 郵便番号 -->
            <el-col :span="6">
              <p>郵便番号</p>
              <el-form-item
                prop="zipcode"
                :rules="[
                  {
                    pattern: /^[0-9\-]+$/,
                    message: '半角英数で入力してください。'
                  }
                ]"
              >
                <el-input
                  v-model="filterConditions.zipcode"
                  placeholder="999-9999"
                  class="e-input"
                  maxlength="8"
                />
              </el-form-item>
            </el-col>

            <!-- 住所 -->
            <el-col :span="18">
              <p>住 所</p>
              <el-form-item prop="address">
                <el-input
                  v-model="filterConditions.address"
                  placeholder="住所"
                  class="e-input"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 4行目: 四十九日法要日・ご契約日 -->
          <el-row :gutter="15">
            <!-- 四十九日法要日 -->
            <el-col :span="12">
              <p>四十九日法要日</p>
              <el-date-picker
                v-model="fortyNinthMemorialServiceDates"
                type="daterange"
                align="right"
                range-separator="〜"
                start-placeholder="期間始め"
                end-placeholder="期間終わり"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
                @change="onChangeFortyNinthMemorialServiceDates"
              />
            </el-col>

            <!-- ご契約日 -->
            <el-col :span="12">
              <p>ご契約日</p>
              <el-date-picker
                v-model="contractDates"
                type="daterange"
                align="right"
                range-separator="〜"
                start-placeholder="期間始め"
                end-placeholder="期間終わり"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
                @change="onChangeContractDates"
              />
            </el-col>
          </el-row>

          <!-- 5行目: 納品日・顧客番号 -->
          <el-row :gutter="15">
            <!-- 納品日 -->
            <el-col :span="12">
              <p>納品日</p>
              <el-date-picker
                v-model="deliveryDates"
                type="daterange"
                align="right"
                range-separator="〜"
                start-placeholder="期間始め"
                end-placeholder="期間終わり"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
                @change="onChangeDeliveryDates"
              />
            </el-col>

            <!-- 顧客番号 -->
            <el-col :span="6">
              <p>顧客番号</p>
              <el-form-item prop="customerNumber">
                <el-input
                  v-model="filterConditions.customerNumber"
                  placeholder=""
                  class="e-input"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 6行目: 備考 -->
          <el-row :gutter="15">
            <!-- 備考 -->
            <el-col :span="12">
              <p>備 考</p>
              <el-form-item prop="note">
                <el-input
                  v-model="filterConditions.note"
                  :autosize="{ minRows: 3, maxRows: 100 }"
                  type="textarea"
                  class="e-input"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <strong>注文情報</strong>

          <!-- 7行目: 注文日・商品名 -->
          <el-row :gutter="15">
            <!-- 注文日 -->
            <el-col :span="12">
              <p>注文日</p>
              <el-date-picker
                v-model="orderedAt"
                type="daterange"
                align="right"
                range-separator="〜"
                start-placeholder="期間始め"
                end-placeholder="期間終わり"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
                @change="onChangeOrderedAt"
              />
            </el-col>

            <!-- 商品名 -->
            <el-col :span="6">
              <p>商品名</p>
              <el-form-item prop="productName">
                <el-input
                  v-model="filterConditions.productName"
                  placeholder="商品名"
                  class="e-input"
                />
              </el-form-item>
            </el-col>

            <!-- 注文番号 -->
            <el-col :span="6">
              <p>注文番号</p>
              <el-form-item prop="orderNumber">
                <el-input
                  v-model="filterConditions.orderNumber"
                  placeholder="注文番号"
                  class="e-input"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <strong v-if="filterConditions.customFields.length">
            自由項目
          </strong>

          <el-row
            v-if="filterConditions.customFields.length"
            :gutter="15"
          >
            <template v-for="item in filterConditions.customFields">
              <el-col
                :key="`customField${item.customFieldNumber}`"
                :span="12"
              >
                <p>{{ fetchCustomFieldLabel(item) }}</p>

                <!-- テキスト型 -->
                <template v-if="fetchCustomFieldType(item) === 'TEXT'">
                  <el-input
                    v-model="item.textContain"
                    clearable
                    @clear="item.textContain = null"
                  />
                </template>

                <!-- テキストリスト型 -->
                <template v-if="fetchCustomFieldType(item) === 'TEXT_LIST'">
                  <el-select
                    v-model="item.textMatch"
                    clearable
                    @clear="item.textMatch = null"
                  >
                    <el-option
                      v-for="(listItem, number) in fetchListItems(item)"
                      :key="`customField${item.customFieldNumber}-list${number}`"
                      :label="listItem"
                      :value="listItem"
                    >
                      {{ listItem }}
                    </el-option>
                  </el-select>
                </template>

                <!-- 整数型 -->
                <template v-if="fetchCustomFieldType(item) === 'INT'">
                  <div class="flex center gaps">
                    <div class="box grow">
                      <el-input
                        v-model="item.intStart"
                        clearable
                        @clear="item.intStart = null"
                      />
                    </div>
                    <div class="box">
                      〜
                    </div>
                    <div class="box grow">
                      <el-input
                        v-model="item.intEnd"
                        clearable
                        @clear="item.intEnd = null"
                      />
                    </div>
                  </div>
                </template>

                <!-- 実数型 -->
                <template v-if="fetchCustomFieldType(item) === 'FLOAT'">
                  <div class="flex center gaps">
                    <div class="box grow">
                      <el-input
                        v-model="item.floatStart"
                        clearable
                        @clear="item.floatStart = null"
                      />
                    </div>
                    <div class="box">
                      〜
                    </div>
                    <div class="box grow">
                      <el-input
                        v-model="item.floatEnd"
                        clearable
                        @clear="item.floatEnd = null"
                      />
                    </div>
                  </div>
                </template>

                <!-- 日付型 -->
                <template v-if="fetchCustomFieldType(item) === 'DATE'">
                  <el-date-picker
                    v-model="item.dates"
                    type="daterange"
                    align="right"
                    range-separator="〜"
                    start-placeholder="期間始め"
                    end-placeholder="期間終わり"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    :editable="false"
                    @change="onChangeCustomFieldDate($event, item)"
                  />
                </template>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </div>

      <!-- footer -->
      <div class="search__footer flex center gaps">
        <div class="box">
          検索条件: {{ computedFilterConditionItems }}
        </div>
        <div class="box grow" />
        <div class="box">
          <el-button
            type="text"
            :disabled="isDisabledSearch"
            @click="reset()"
          >
            条件をリセット
          </el-button>
        </div>
        <div class="box">
          <el-button
            type="primary"
            :disabled="isDisabledSearch"
            @click="search"
          >
            検索する
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { apiErrorHandler } from "@/services/apiErrorHandler";
import UserUsecase from "@/usecases/user.usecase";
import OrderUsecase from "@/usecases/order.usecase";

// const DATE_FORMAT = "YYYY-MM-DD";

const BASE_FILTER_CONDITIONS = {
  status: null,
  // 1行目: 店舗・支店
  clientGroupId: null,
  deliveryDestinationId: null,
  // 2行目: お名前・郵便番号・住所・電話番号
  customerName: null,
  zipcode: null,
  address: null,
  tel: null,
  // 3行目: 四十九日法要日・ご契約日
  fortyNinthMemorialServiceDateStart: null,
  fortyNinthMemorialServiceDateEnd: null,
  contractDateStart: null,
  contractDateEnd: null,
  // 4行目: 納品日・顧客番号
  deliveryDateStart: null,
  deliveryDateEnd: null,
  customerNumber: null,
  // 5行目: 備考
  note: null,
  // 6行目: 注文日・商品名
  orderedAtStart: null,
  orderedAtEnd: null,
  productName: null,
  // 自由項目
  customFields: [],
  // 未使用
  productVariationId: null,
  orderNumber: null,
};

const PICKER_OPTIONS = Object.freeze({
  shortcuts: [
    {
      text: "過去１週間",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "過去１ヶ月",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "過去３ヶ月",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "過去半年",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "過去１年",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "過去２年",
      onClick (picker) {
        const start = new Date();
        const end = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 2);
        picker.$emit("pick", [start, end]);
      },
    },
  ],
});

export default {
  name: "HomeFilter",
  props: {
    status: String,
    isShowFilterModal: Boolean,
    isFiltered: Boolean,
  },
  data () {
    return {
      filterConditions: _.cloneDeep(BASE_FILTER_CONDITIONS),
      // 店舗情報 > 店舗
      clientGroupList: [],
      clientGroup: {},
      // 店舗情報 > 支店
      deliveryDestinationList: [],
      deliveryDestination: {},
      // 四十九日法要日
      fortyNinthMemorialServiceDates: null,
      // ご契約日
      contractDates: null,
      // 納品日
      deliveryDates: null,
      // 注文日
      orderedAt: null,
      // その他
      requireRefresh: false,
      pickerOptions: PICKER_OPTIONS,
      // 自由項目
      itemSettings: [],
      // ローディング
      loadingView: null,
    };
  },
  computed: {
    isDisabledSearch () {
      const { filterConditions } = this;
      const isAvailable = Object.keys(filterConditions).find((key) => {
        return filterConditions[key] !== null && filterConditions[key] !== "";
      });

      if (isAvailable) {
        return false;
      }

      return true;
    },
    computedFilterConditionItems () {
      const {
        clientGroupId,
        deliveryDestinationId,
        customerName,
        zipcode,
        address,
        tel,
        fortyNinthMemorialServiceDateStart,
        contractDateStart,
        deliveryDateStart,
        customerNumber,
        note,
        orderedAtStart,
        productName,
        orderNumber,
      } = this.filterConditions;
      const filterItems = [];

      if (clientGroupId) {
        filterItems.push("店舗");
      }
      if (deliveryDestinationId) {
        filterItems.push("支店");
      }
      if (customerName) {
        filterItems.push("お名前");
      }
      if (zipcode) {
        filterItems.push("郵便番号");
      }
      if (address) {
        filterItems.push("住所");
      }
      if (tel) {
        filterItems.push("電話番号");
      }
      if (fortyNinthMemorialServiceDateStart) {
        filterItems.push("四十九日法要日");
      }
      if (contractDateStart) {
        filterItems.push("ご契約日");
      }
      if (deliveryDateStart) {
        filterItems.push("納品日");
      }
      if (customerNumber) {
        filterItems.push("顧客番号");
      }
      if (note) {
        filterItems.push("備考");
      }
      if (orderedAtStart) {
        filterItems.push("注文日");
      }
      if (productName) {
        filterItems.push("商品名");
      }
      if (orderNumber) {
        filterItems.push("注文番号");
      }

      const listOfFilterItems = filterItems.join(", ");

      return listOfFilterItems ? `[ ${listOfFilterItems} ]` : "未選択";
    },
    localIsShowFilterModal: {
      get () {
        return this.isShowFilterModal;
      },
      set (value) {
        if (this.requireRefresh) {
          this.$emit("onChangeStatus");
        }
        this.$emit("update:isShowFilterModal", value);
        this.requireRefresh = false;
      },
    },
  },
  watch: {
  },
  created () {
    this.restoreFilterState();
  },
  async mounted () {
    this.clientGroupList = await this.fetchClientGroupList();
  },
  methods: {
    restoreFilterState () {
      const filter = localStorage.getItem("filter");

      if (filter) {
        const values = JSON.parse(filter);
        const {
          filterConditions,
          clientGroup,
          deliveryDestination,
          fortyNinthMemorialServiceDates,
          contractDates,
          deliveryDates,
          orderedAt,
          itemSettings,
        } = values;

        this.filterConditions = filterConditions;
        this.clientGroup = clientGroup;
        this.deliveryDestination = deliveryDestination;
        this.fortyNinthMemorialServiceDates = fortyNinthMemorialServiceDates;
        this.contractDates = contractDates;
        this.deliveryDates = deliveryDates;
        this.orderedAt = orderedAt;
        this.itemSettings = itemSettings;
      }
    },

    keepFilterState () {
      const {
        filterConditions,
        clientGroup,
        deliveryDestination,
        fortyNinthMemorialServiceDates,
        contractDates,
        deliveryDates,
        orderedAt,
        itemSettings,
      } = this;

      const values = {
        filterConditions,
        clientGroup,
        deliveryDestination,
        fortyNinthMemorialServiceDates,
        contractDates,
        deliveryDates,
        orderedAt,
        itemSettings,
      };

      localStorage.setItem("filter", JSON.stringify(values));
    },

    async fetchClientGroupList () {
      try {
        const payload = {
          userId: this.$store.state.user.sub,
        };

        // Query.me から店舗一覧を取得
        const user = await userUsecase.getMe(payload);
        return user.clientGroups;
      } catch (err) {
        apiErrorHandler(this, err, () => {});
      }
    },

    /**
     * [reset description]
     * @param   {[type]}  isForce  [isForce description]
     */
    reset (isForce = false) {
      if (
        !isForce &&
        !window.confirm("選択中の条件をリセットしてもよろしいですか？")
      ) {
        return;
      }

      this.filterConditions = _.cloneDeep(BASE_FILTER_CONDITIONS);
      this.clientGroup = {};
      this.deliveryDestination = {};
      this.deliveryDestinationList = [];
      this.fortyNinthMemorialServiceDates = null;
      this.contractDates = null;
      this.deliveryDates = null;
      this.orderedAt = null;
      this.itemSettings = [];
      if (this.isFiltered) {
        this.requireRefresh = true;
      }
      this.$emit("onResetFilterConditions");

      localStorage.removeItem("filter");
    },

    search () {
      const filterConditions = this.fetchFilterConditions();

      this.localIsShowFilterModal = false;
      this.keepFilterState();
      this.$emit("onChangeFilterConditions", filterConditions);
    },

    fetchFilterConditions () {
      const { status } = this;
      const filterConditions = {
        ...this.filterConditions,
      };
      filterConditions.status = status === "ALL" ? undefined : status;
      filterConditions.customFields = filterConditions.customFields.map(customField => {
        delete customField.dates;

        return customField;
      });

      return filterConditions;
    },

    /**
     * [fetchCustomFields description]
     */
    async fetchCustomFields () {
      const { clientGroupId } = this.filterConditions;

      // 初期化
      this.itemSettings = [];
      this.filterConditions.customFields = [];

      if (!clientGroupId) {
        return;
      }

      this.loadingView = this.$loading();

      try {
        const res = await this.fetchOrderCustomFieldConfig();

        this.setCustomFields(res);
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.loadingView.close();
      }
    },

    /**
     * [fetchOrderCustomFieldConfig description]
     * @return  {[type]}  [return description]
     */
    async fetchOrderCustomFieldConfig () {
      const options = this.fetchOrderCustomFieldOptions();
      const res = await orderUsecase.getOrderCustomFieldConfig(options);

      return res;
    },

    /**
     * [fetchOrderCustomFieldOptions description]
     * @return  {[type]}  [return description]
     */
    fetchOrderCustomFieldOptions () {
      const { clientGroupId } = this.filterConditions;
      const options = { clientGroupId };

      return options;
    },

    /**
     * [setCustomFields description]
     * @param   {[type]}  res  [res description]
     */
    setCustomFields (res) {
      if (!res.data) {
        return;
      }

      const itemSettings = [];

      // 管理画面で登録された自由項目から enabled の項目のみ取得する
      res.data.orderCustomFieldConfig.itemSettings
        .sort((a, b) => {
          return a.order < b.order ? -1 : 1;
        })
        .forEach(itemSetting => {
          if (itemSetting.enabled) {
            itemSettings.push(itemSetting);
          }
        });

      // 得意先での自由項目の入力形式で形成
      const fetchCustomFieldByType = (type, customFieldNumber) => {
        if (type === "INT") {
          return {
            customFieldNumber,
            intStart: null,
            intEnd: null,
          };
        }

        if (type === "FLOAT") {
          return {
            customFieldNumber,
            floatStart: null,
            floatEnd: null,
          };
        }

        if (type === "DATE") {
          return {
            customFieldNumber,
            dates: null,
            dateStart: null,
            dateEnd: null,
          };
        }

        // textMatch: 完全一致
        // textContain: 部分一致
        if (type === "TEXT_LIST") {
          return {
            customFieldNumber,
            textMatch: null,
          };
        }

        // type === "TEXT"
        return {
          customFieldNumber,
          textContain: null,
        };
      };

      const customFields = itemSettings.map((itemSetting) => {
        const {
          customFieldNumber,
          type,
        } = itemSetting;
        const customField = fetchCustomFieldByType(type, customFieldNumber);

        return customField;
      });

      this.itemSettings = itemSettings;
      this.filterConditions.customFields = customFields;
    },

    /**
     * [fetchCustomFieldLabel description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchCustomFieldLabel (item) {
      const { itemSettings } = this;
      const { customFieldNumber } = item;
      const target = itemSettings.find(itemSetting => itemSetting.customFieldNumber === customFieldNumber);

      return target ? target.name : "不明な項目";
    },

    /**
     * [fetchCustomFieldType description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchCustomFieldType (item) {
      const { itemSettings } = this;
      const { customFieldNumber } = item;
      const target = itemSettings.find(itemSetting => itemSetting.customFieldNumber === customFieldNumber);

      return target ? target.type : "TEXT";
    },

    /**
     * [fetchListItems description]
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    fetchListItems (item) {
      const { itemSettings } = this;
      const { customFieldNumber } = item;
      const target = itemSettings.find(itemSetting => itemSetting.customFieldNumber === customFieldNumber);

      return target.listItems || [];
    },

    onChangeCustomFieldDate (event, item) {
      if (event) {
        item.dateStart = event[0];
        item.dateEnd = event[1];
      } else {
        item.dateStart = null;
        item.dateEnd = null;
      }
    },

    onChangeClientGroup (event) {
      this.filterConditions.clientGroupId = event.id || null;
      this.filterConditions.deliveryDestinationId = null;
      this.clientGroup = { ...event };
      this.deliveryDestination = {};
      this.deliveryDestinationList = event.deliveryDestinations || [];

      // customFields
      this.fetchCustomFields();
    },

    onChangeDeliveryDestination (event) {
      this.filterConditions.deliveryDestinationId = event.id || null;
      this.deliveryDestination = { ...event };
    },

    onChangeFortyNinthMemorialServiceDates (event) {
      if (event) {
        this.filterConditions.fortyNinthMemorialServiceDateStart = event[0];
        this.filterConditions.fortyNinthMemorialServiceDateEnd = event[1];
      } else {
        this.filterConditions.fortyNinthMemorialServiceDateStart = null;
        this.filterConditions.fortyNinthMemorialServiceDateEnd = null;
      }
    },

    onChangeContractDates (event) {
      if (event) {
        this.filterConditions.contractDateStart = event[0];
        this.filterConditions.contractDateEnd = event[1];
      } else {
        this.filterConditions.contractDateStart = null;
        this.filterConditions.contractDateEnd = null;
      }
    },

    onChangeDeliveryDates (event) {
      if (event) {
        this.filterConditions.deliveryDateStart = event[0];
        this.filterConditions.deliveryDateEnd = event[1];
      } else {
        this.filterConditions.deliveryDateStart = null;
        this.filterConditions.deliveryDateEnd = null;
      }
    },

    onChangeOrderedAt (event) {
      if (event) {
        this.filterConditions.orderedAtStart = moment(event[0]).unix();
        this.filterConditions.orderedAtEnd = moment(event[1]).add(1, "d").subtract(1, "s").unix();
      } else {
        this.filterConditions.orderedAtStart = null;
        this.filterConditions.orderedAtEnd = null;
      }
    },
  },
};

const userUsecase = new UserUsecase();
const orderUsecase = new OrderUsecase();
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';

::v-deep .el-dialog {
  &__header {
    display: none;
  }

  &__body {
    height: 100%;
    position: relative;
    padding: 0 !important;

    .search {
      display: grid;
      min-height: 100%;
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;
      text-align: left;

      &__header {
        position: sticky;
        left: 0;
        top: 0;
        padding: 12px 12px 12px 20px;
        border-bottom: 1px solid $--border-color-base;
        background-color: white;
        z-index: 1;

        .title {
          margin: 0;
          font-size: 1.25rem;
        }
      }

      &__body {
        padding: 12px 18px;
        background: $background-gray-lighter;
      }

      &__footer {
        position: sticky;
        left: 0;
        bottom: 0;
        padding: 12px 12px 12px 20px;
        // border-top: 1px solid $--border-color-base;
        background-color: $background-gray-light;
        z-index: 1;
      }
    }
  }
}

.el-icon-search {
  padding-right: 10px;
  transform: scale(1.25);
}

.el-form-item,
.el-select {
  width: 100%;
}

.el-select-dropdown__item {
  font-weight: normal !important;
}

.el-range-editor.el-input__inner {
  width: 100%;

  ::v-deep .el-range__close-icon {
    float: inherit;
    position: absolute;
    right: 10px;
  }
}
</style>
